module.exports = __webpack_public_path__ + "img/MangoSTEEMS_logo.c4348488.png";